export default __webpack_public_path__ + "static/media/480_business04-es-mobile.12292dc3.png";